import React, { useState } from 'react';
import { Typography, Modal, Table } from 'antd';
import { currency } from '../../quotationProduct/formatNumber';
const columns = [
  {
    title: '费用项',
    dataIndex: 'cost_name',
    key: 'cost_name',
  },
  {
    title: '计费方式',
    dataIndex: 'cost_amount',
    key: 'cost_amount',
    render: (_, record) => {
      const { cost_amount, cost_mode } = record;
      return `${+cost_mode === 1 ? currency(cost_amount) + '元' : cost_amount + '%'}`;
    }
  },
  {
    title: '费用金额（元）',
    dataIndex: 'cost_type',
    key: 'cost_type',
    render: (_, record) => {
      const { cost_amount, cost_mode, total_amount } = record;
      return currency(+cost_mode === 1 ? cost_amount : total_amount * cost_amount / 100);
    }
  },
  {
    title: '费用说明',
    dataIndex: 'cost_explain',
    key: 'cost_explain',
  },
];

export default function RenderCostDetail(props = {}) {
  const [modalVisible, setModalVisible] = useState(false);
  const { freight_amount, expense_details = [], cost_info = [], total_amount } = props.record;
  const openModal = () => {
    setModalVisible(true);
  };
  const handleCancel = () => {
    setModalVisible(false);
  };
  return (<>
    <div>
      <span>¥{currency(+freight_amount)}</span>
      <Typography.Link className='bill-operate-btn promote-btn' onClick={openModal}> 明细</Typography.Link>
    </div>
    <Modal
      open={modalVisible}
      centered
      footer={false}
      onCancel={handleCancel}
      width={800}
      title='费用明细'
    >
      <Table
        columns={columns}
        bordered
        dataSource={([...expense_details, ...cost_info]).map((item, index) => ({ ...item, index, total_amount }))}
        rowKey='index'
        pagination={false}
        scroll={{ y: 400 }}
      />
      <div style={{ textAlign: 'right', padding: 20 }}>费用总计(元)：¥{currency(freight_amount)}</div>
    </Modal>
  </>);
}
